/**
 * Справочник локалей, доступных для настройки на платформе.
 *
 * Значения соответствуют тому, что хранит backend (Platform.languages и
 * Platform.default_language) и что понимает концьерж (i18n namespaces).
 * Если добавляешь новую локаль — не забудь:
 *  1) добавить ресурсы в concierge-2.0/public/locales/<lang>/
 *  2) добавить локаль в CHOICES бэкенда (serverapp/models/platform.py)
 *  3) проверить, что LLM-перевод (`/api/v1/i18n/translate`) умеет target_locale.
 */
export interface PlatformLocale {
  /** ISO-тег, как хранится в БД и передаётся гостю */
  value: string;
  /** Полный лейбл с флагом для Select */
  label: string;
  /** Короткая метка (2-3 символа) для табов/тегов */
  short: string;
}

export const PLATFORM_LOCALES: PlatformLocale[] = [
  { value: 'ru-RU', label: '🇷🇺 Русский', short: 'RU' },
  { value: 'en-US', label: '🇬🇧 English', short: 'EN' },
  { value: 'pl-PL', label: '🇵🇱 Polski', short: 'PL' },
  { value: 'zh-CN', label: '🇨🇳 简体中文', short: '中' },
];

export const LOCALE_LABEL: Record<string, string> = Object.fromEntries(
  PLATFORM_LOCALES.map((l) => [l.value, l.label]),
);

export const LOCALE_SHORT: Record<string, string> = Object.fromEntries(
  PLATFORM_LOCALES.map((l) => [l.value, l.short]),
);
